import { prefix } from './obfuscate-string';
var deobfuscateString = function deobfuscateString() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (string.startsWith(prefix)) {
    var decoded = string.replace(prefix, '');
    if (typeof window !== 'undefined' && window.atob) {
      decoded = window.atob(decoded);
    } else {
      decoded = Buffer.from(decoded, 'base64').toString('ascii');
    }
    return decoded;
  }
  return string;
};
export default deobfuscateString;